import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
@Injectable()
export class SessionInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    return next.handle(request).do((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // do stuff with response if you want
        }
      }, (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 403 && (err.error.code === 'S0001' || err.error.code === 'S9999' || err.error.message.code === 'S0001')) {
            localStorage.removeItem('authToken');
            sessionStorage.removeItem('authToken');
            this.router.navigate(['/auth/login']);
          } else if (err.status === 403 && (err.error.code === 'S0002')) {
            localStorage.removeItem('authToken');
            sessionStorage.removeItem('authToken');
            this.router.navigate(['/profile'])
          }
        }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/interceptors/session.interceptor.ts